import React, { Component } from 'react';
import Footer from './Footer';
import Header from '../user/common/Header';
import axios from 'axios';
import store from '../../store/index';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { Helmet } from 'react-helmet';
import { BannerTopIframe } from './BannerFrame';
import arrow_back from './../../assets/icons/arrow-back.svg';

class BlogDetail extends Component {
    constructor(props) {
        super(props);
        this.userInfo = store.getState().auth.userInfo;
        const { dispatch } = props;
        this.dispatch = dispatch;

        this.state = {
            blogDetails: [],
            loading: true,
            error: null,
            copySuccess: false,
        };
    }

    componentDidMount() {
        this.getBlogDetails();
    }

    componentDidUpdate(prevProps) {
        // If user navigates to a different blog slug without unmounting this component,
        // refetch details.
        const prevSlug = prevProps.match?.params?.slug;
        const nextSlug = this.props.match?.params?.slug;
        if (prevSlug !== nextSlug) {
            this.getBlogDetails();
        }
    }

    decodeHtmlEntities = (value) => {
        if (typeof value !== 'string') return '';
        // Decode &lt; &gt; &amp; etc.
        const textarea = document.createElement('textarea');
        textarea.innerHTML = value;
        return textarea.value;
    }

    normalizeBlogHtml = (raw) => {
        if (typeof raw !== 'string') return '';

        // If backend stored content as escaped HTML, decode it first.
        let html = this.decodeHtmlEntities(raw);

        // Some blog posts seem to store a FULL HTML document (<!DOCTYPE html><html>...)
        // We only want the <body> content.
        const looksLikeFullDoc = /<!doctype\s+html|<html[\s>]/i.test(html);
        if (looksLikeFullDoc) {
            try {
                const parsed = new DOMParser().parseFromString(html, 'text/html');
                html = parsed?.body?.innerHTML || html;
            } catch (e) {
                // ignore parse issues and just fallback to html
            }
        }

        // Finally sanitize before rendering.
        return DOMPurify.sanitize(html);
    }

    getBlogDetails = () => {
        const { slug } = this.props.match.params;
        console.log("slug", slug)
        this.setState({ loading: true, error: null });
        axios.get(`/front/blogDetail/${slug}`).then((response) => {
            console.log("Blog Detail : ", response.data.data)
            let result = response.data.data;

            const post = Array.isArray(result) ? result[0] : result;
            if (!post) {
                this.setState({ blogDetails: [], loading: false, error: 'Blog not found' });
                return;
            }

            const blogDescription = this.normalizeBlogHtml(post.description);
            const blogPostDetails = [{
                id: post._id,
                title: post.title,
                category: post.category,
                image: post.image,
                descriptionHtml: blogDescription,
                updatedAt: post.updatedAt,
                seo: post.seo,
                slug: post.slug,
                seodescription: post.seodescription,
                keywords: post.keywords
            }];

            this.setState({ blogDetails: blogPostDetails, loading: false, error: null });
        }).catch((error) => {
            console.error('Error:', error);
            this.setState({ loading: false, error: error?.message || 'Failed to load blog detail' });
        });
    }

    // Share Functions
    shareOnFacebook = (url, title) => {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(fbUrl, '_blank', 'width=600,height=400');
    }

    shareOnTwitter = (url, title) => {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
        window.open(twitterUrl, '_blank', 'width=600,height=400');
    }

    shareOnLinkedIn = (url) => {
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        window.open(linkedInUrl, '_blank', 'width=600,height=400');
    }

    shareOnWhatsApp = (url, title) => {
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`;
        window.open(whatsappUrl, '_blank');
    }

    shareViaEmail = (url, title, description) => {
        const subject = encodeURIComponent(title);
        const body = encodeURIComponent(`${description}\n\nRead more: ${url}`);
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
    }

    copyToClipboard = (url) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(() => {
                this.setState({ copySuccess: true });
                setTimeout(() => {
                    this.setState({ copySuccess: false });
                }, 2000);
            }).catch((err) => {
                console.error('Failed to copy: ', err);
            });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.setState({ copySuccess: true });
                setTimeout(() => {
                    this.setState({ copySuccess: false });
                }, 2000);
            } catch (err) {
                console.error('Fallback: Failed to copy', err);
            }
            document.body.removeChild(textArea);
        }
    }

    render() {
        const { blogDetails, loading, error, copySuccess } = this.state;

        if (loading) {
            return <SpinnerLoader />
        }
        if (error) {
            return <div>Error: {error}</div>;
        }

        console.log("blog Details under render", blogDetails)
        return (
            <React.Fragment>
                {loading === true ? <SpinnerLoader /> : ''}
                <Header />
                <div className="inr_top_page_title">
                    <h2>Blog Detail</h2>
                </div>
                <section className="inr_wrap mt-2">
                    {blogDetails.map((item, index) => {
                        const shareUrl = `${window.location.origin}/blog-detail/${item.slug}`;
                        const shareTitle = item.title;
                        const shareDescription = item.seodescription || item.title;

                        return (
                            <div className="container" key={item._id || index}>
                                <BannerTopIframe keywords={item.keywords} />

                                <div className="row">
                                    <div className="col-md-12 cart-single-page-wrapper">
                                        <div className="cart my_cart" style={{ paddingRight: '15px' }}>
                                            <div className="cl_head">
                                                <Helmet>
                                                    <title>{`Blog-detail/${item.slug}`}</title>
                                                    <meta name="description" content={item.seodescription} />
                                                    <meta name="keywords" content={item.keywords} />
                                                </Helmet>

                                                <div className="cart-single-heading d-flex align-items-center">
                                                    <h1 className="mb-0">{item.title}</h1>

                                                    <Link
                                                        to="#"
                                                        className="custom_btn btn_yellow btn btn-sm ms-auto"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            window.history.back();
                                                        }}
                                                    >
                                                        <img src={arrow_back} alt="back" loading="lazy" decoding="async" />&nbsp;
                                                        Back
                                                    </Link>
                                                </div>

                                                <div className="blog-list-meta">
                                                    <span className="post_cat_col">{item.category}</span>
                                                    <span className="post_date_col">
                                                        {new Date(item.updatedAt).toLocaleDateString()}
                                                    </span>
                                                </div>

                                                {item.image && (
                                                    <div className="blog-page-image">
                                                        <img
                                                            src={item.image}
                                                            height={680}
                                                            width={1080}
                                                            alt={item.title}
                                                            loading="lazy"
                                                            decoding="async"
                                                        />
                                                    </div>
                                                )}

                                                <div className="blog-single-desc">
                                                    <div
                                                        className='blog-fullInfo'
                                                        dangerouslySetInnerHTML={{ __html: item.descriptionHtml || '' }}
                                                    />
                                                </div>

                                                {/* Share buttons - Bottom placement */}
                                                <div className="blog-share-section blog-share-bottom">
                                                    <span className="share-label">Share this article:</span>
                                                    <div className="blog-share-buttons">
                                                        <button
                                                            className="share-btn facebook-btn"
                                                            onClick={() => this.shareOnFacebook(shareUrl, shareTitle)}
                                                            title="Share on Facebook"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            className="share-btn twitter-btn"
                                                            onClick={() => this.shareOnTwitter(shareUrl, shareTitle)}
                                                            title="Share on Twitter"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            className="share-btn linkedin-btn"
                                                            onClick={() => this.shareOnLinkedIn(shareUrl)}
                                                            title="Share on LinkedIn"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            className="share-btn whatsapp-btn"
                                                            onClick={() => this.shareOnWhatsApp(shareUrl, shareTitle)}
                                                            title="Share on WhatsApp"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            className="share-btn email-btn"
                                                            onClick={() => this.shareViaEmail(shareUrl, shareTitle, shareDescription)}
                                                            title="Share via Email"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                                            </svg>
                                                        </button>

                                                        <button
                                                            className="share-btn copy-btn"
                                                            onClick={() => this.copyToClipboard(shareUrl)}
                                                            title="Copy link"
                                                        >
                                                            {copySuccess ? (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                                                                </svg>
                                                            ) : (
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                                                                </svg>
                                                            )}
                                                        </button>
                                                    </div>
                                                    {copySuccess && <span className="copy-success-msg">Link copied to clipboard!</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </section>

                <Footer />
            </React.Fragment>
        );
    }
}

export default BlogDetail;
